import api from 'Application/api/api';

const getContractsFilterRange = signal =>
	api.get('/finances/totals/revisions?size=9999', {
		signal,
	});

export default getContractsFilterRange;
